import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';

@Component({
  selector: 'app-section1-2',
  templateUrl: './section1-2.component.html',
  styleUrls: ['./section1-2.component.css'],
  providers : [LogisticsService]
})
export class Section12Component implements OnInit {
  @Input("role") role;
  totalIntransitPerYear:any;
  branchWiseShipments:any;
  currentDate:any;
  datetoday:any;
  currency:any;
  constructor(private db:AngularFireDatabase, private ls:LogisticsService) { }

  ngOnInit() {
    this.currentDate = new Date();
    this.datetoday = this.currentDate.getDate()+"/"+(this.currentDate.getMonth() + 1)+"/"+this.currentDate.getFullYear();
    this.getBranchWiseData();
    this.getCurrency();
  }
  getCurrency()
  {
    this.ls.currency.subscribe(currency => {
      this.currency = currency; 
    });
  }
  getBranchWiseData()
  {
    this.db.list("branches").snapshotChanges().subscribe(item=>{
      this.totalIntransitPerYear = 0;
      this.branchWiseShipments = [];
        item.forEach(element =>{
          firebase.database().ref("shipments").orderByChild("branch").equalTo(element.key).on("value",(snapshot)=>{
            var data = snapshot.val();
            if(data!=null)
            {
              var y = element.payload.toJSON();
              
              var total = 0;
              var totalOrders = 0;
              for(let i in data)
              {
                var date1 = null;
                var date2 = null;
                if(data[i].source.date!=null)
                {
                  date1 = data[i].source.date.day + "/"+ data[i].source.date.month + "/"+ data[i].source.date.year; 
                }
                if(data[i].destination.date!=null)
                {
                  date2 =  data[i].destination.date.day + "/"+ data[i].destination.date.month + "/"+ data[i].destination.date.year; 
                }
                //console.log("datetoday",this.datetoday, date1, date2);
                if(date1 == this.datetoday || date2 == this.datetoday)
                {
                  totalOrders++;
                  if(data[i].cashCollected)
                  total = total + data[i].cashCollected;
                }
              }
              y["totalShipments"] = totalOrders;
              y["totalCash"] = total;
              this.branchWiseShipments.push(y);
              //console.log("branchWiseShipments",this.branchWiseShipments);
            }
            else
            {
              var y = element.payload.toJSON();
              y["totalShipments"] = 0;
              y["totalCash"] = 0;
              this.branchWiseShipments.push(y);
              //console.log("branchWiseShipments",this.branchWiseShipments);
            }
          });
        });
      });
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/section1-2/section1-2.component.ts